import { ChassisLevel } from '@components/arsenal/chassis/ChassisLevel';
import { HoverMenu } from '@components/helpers/HoverMenu';
import { useActivateChassisMutation } from '@http';
import { capitalize } from '@helpers/dotNotation';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';

interface ChassisButtonProps {
  chassis: Shared.ChassisData;
  index: number;
  onView: () => void;
  onUpgrade: () => void;
};

export function ChassisButton({ chassis, index, onView, onUpgrade }: ChassisButtonProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Chassis' });
  const { userData, refetch, setIsFetching } = useAppStore();
  const { mutateAsync } = useActivateChassisMutation();

  const getClasses = () => {
    const base = index % 2 === 0 ? 'border-r-1' : '';
    const added = index % 3 !== 2 ? 'lg:border-r-1' : '';
    return `chassis-button border-b-1 border-0 bg-transparent ${base} ${added}`;
  };

  const isActive = userData.chassis.some(c => c.key === chassis.key && c.active);
  const userChassis = userData.chassis.find(c => c.key === chassis.key);
  if (!userChassis) return null;

  const equip = async () => {
    setIsFetching(true);
    await mutateAsync({ id: userChassis.id });
    refetch();
  };

  const hoverItems = [
    {
      label: t('equip'),
      className: 'btn-active',
      visible: !isActive,
      onClick: equip
    },
    {
      label: t('upgrade'),
      className: isActive ? 'btn-active' : '',
      onClick: onUpgrade
    },
    {
      label: t('view'),
      onClick: onView
    },
  ];

  return (
    <HoverMenu className={getClasses()} items={hoverItems}>
      <div className="bg-1" />
      <img
        src={`/img/chassis/${chassis.key}.avif`}
        className="chassis-img blur-animation"
        alt={chassis.key}
      />
      <div className="bg-2" />

      <div className="text-container">
        <div className="w-full">
          <div className="flex items-center justify-center pb-1">
            <p className="chassis-name">{capitalize(chassis.key)}</p>
          </div>
          <ChassisLevel xp={userChassis.xp} />
        </div>
        {isActive && <p className="chassis-active">{t('active')}</p>}
      </div>
    </HoverMenu>
  );
}